import _ from 'lodash';
import qs from 'qs';
// 顶级域名, 二级域名 ...
export function getLevelDomain(url, level = 1) {
    url = _.trim(url);
    if (!url) {
        return url;
    }
    // 去掉 http://
    let idx = url.search('://');
    if (idx >= 0) {
        url = url.substring(idx + 3);
    }
    // 去掉 尾部的 /
    idx = url.search('/');
    if (idx >= 0) {
        url = url.substring(0, idx);
    }
    // 去掉端口
    idx = url.search(':');
    if (idx >= 0) {
        url = url.substring(0, idx);
    }
    const parts = url.split('.');
    const resParts = _.takeRight(parts, level + 1); // 需要 + 1
    return resParts.join('.');
}
export function withQuery(url = '', query) {
    const queryString = qs.stringify(query);
    const parts = [url];
    if (url.indexOf('?') === -1) {
        parts.push('?');
    }
    else {
        parts.push('&');
    }
    parts.push(queryString);
    const fullUrl = parts.join('');
    return fullUrl;
}
export function withoutQuery(href = '', fields) {
    const queryIndex = href.indexOf('?');
    if (queryIndex === -1) {
        return href;
    }
    const hashIndex = href.indexOf('#');
    let hash = '';
    if (hashIndex !== -1) {
        hash = href.substring(hashIndex);
    }
    const hrefPrefix = href.substring(0, queryIndex);
    const queryStr = href.substring(queryIndex + 1);
    const query = qs.parse(queryStr);
    _.each(fields, field => {
        delete query[field];
    });
    if (_.isEmpty(query)) {
        return hrefPrefix + hash;
    }
    return `${hrefPrefix}?${qs.stringify(query)}${hash}`;
}
export function appendTimestamp(url, time_key = '_timestamp') {
    return withQuery(url, {
        [time_key]: Date.now(),
    });
}
